import { customerDistributionTypesSlice } from "./customerDistributionTypesSlice";
import * as actions from "./customerDistributionTypesActions";
import * as selectors from "./customerDistributionTypesSelectors";

export { actions };
export { selectors };
export default customerDistributionTypesSlice.reducer;